import { makeGetSelectors } from "@/utils/redux/selector";
import { USER_STATE_KEY_LIST } from "@/redux/user/slice";

export const { getUserInfo, getUserInfoFetchState } = makeGetSelectors(
	"user",
	USER_STATE_KEY_LIST,
);
